import { useEffect, useState } from 'react'

import { API } from '@/api'
import { Trans } from '@/components'
import { SnapshottingStatuses } from '@/models/instance'
import { useTeamStore } from '@/stores/team'

export function AdminStatsCards() {
  const teamStore = useTeamStore()
  const [totalInstances, setTotalInstances] = useState(0)
  const [maxInstances, setMaxInstances] = useState(0)
  const [snapshotsInProgress, setSnapshotsInProgress] = useState(0)

  useEffect(() => {
    const fetchStats = async () => {
      const teamResID = teamStore.teamTokenData?.teamResID
      if (!teamResID) {
        return
      }

      try {
        // Fetch instance statistics and snapshots in progress in parallel
        const [statsRes, snapshotRes] = await Promise.all([
          API.getTeamStatOverview({ res_id: teamResID }),
          API.getTeamMemberInstances({
            res_id: teamResID,
            statuses: SnapshottingStatuses,
            page: 1,
            per_page: 1,
          }),
        ])

        setTotalInstances(statsRes.memberInstanceOverview.usage)
        setMaxInstances(statsRes.memberInstanceOverview.quota)
        setSnapshotsInProgress(snapshotRes.pagination.total)
      } catch (error) {
        console.error('Failed to fetch admin stats:', error)
      }
    }

    fetchStats()
  }, [teamStore.teamTokenData?.teamResID])

  return (
    <div className="grid grid-cols-2 gap-4 mb-6">
      {/* Instances Card */}
      <div className="border border-neutral-200 shadow-sm rounded-2xl p-6">
        <div className="t-x-sb text-secondary mb-2">
          <Trans i18nKey="team.admin.stats.instances">Instances</Trans>
        </div>
        <div className="h5 text-primary">
          {totalInstances} / <span className="text-tertiary">{maxInstances}</span>
        </div>
      </div>

      {/* Snapshots in Progress Card */}
      <div className="border border-neutral-200 shadow-sm rounded-2xl p-6">
        <div className="t-x-sb text-secondary mb-2">
          <Trans i18nKey="team.admin.stats.snapshotsInProgress">
            Instances with Snapshots in Progress
          </Trans>
        </div>
        <div className="h5 text-primary">{snapshotsInProgress}</div>
      </div>
    </div>
  )
}
